import { useState } from "react";
import Modal from "react-modal";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer/Footer";
import Nav from "./components/Navbar/Nav";
import Home from "./Pages/Home/Home";
import Login from "./Pages/Login/Login";

function App() {
  const customStyles = {
    content: {
      margin: "auto",
      width: "80vw",
      height: "80vh",
      overflow: "none",
    },
  };
  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  return (
    <div className="App">
      <BrowserRouter>
        <Nav
          modOpen={modalIsOpen}
          setMod={setIsOpen}
          openMod={openModal}
          closeMod={closeModal}
        />
        <Routes>
          <Route
            path="/"
            element={
              <Home
                modOpen={modalIsOpen}
                setMod={setIsOpen}
                openMod={openModal}
                closeMod={closeModal}
              />
            }
          />
          <Route
            path="login"
            element={
              <Login
                modOpen={modalIsOpen}
                setMod={setIsOpen}
                openMod={openModal}
                closeMod={closeModal}
              />
            }
          />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
      >
        <button className="close" onClick={closeModal}>
          &times;
        </button>
        <iframe
          src="https://cdn.forms-content.sg-form.com/a473d9f7-ac0c-11ed-87b9-6661844c553d"
          width="100%"
          height="100%"
          className="frame"
        >
          {" "}
        </iframe>
      </Modal>
    </div>
  );
}

export default App;
